/* import __COLOCATED_TEMPLATE__ from './user.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();